import { r as e, t } from "./shapes-BQUVJdp5.js";
import { i as n, n as r, r as i, t as a } from "./CourseWare-BTFRjgBR.js";
import { t as o } from "./chess-E2uOAyQS.js";
import { t as s } from "./french-Dk7YG8Td.js";
import { t as c } from "./math-B4HbgYf6.js";
import { a as l, i as u, n as d, o as f, r as p, t as m } from "./piano-DF1g6yaX.js";
import { t as h } from "./pitch-CgGJFkZ1.js";
import { t as g } from "./sightsing-BFQ7HRig.js";
import { t as _ } from "./typing-BevtfWlp.js";
import { t as v } from "./word-work-BOnRlZgd.js";
import { Fragment as y, computed as b, createBlock as x, createCommentVNode as S, createElementBlock as C, createElementVNode as w, createTextVNode as T, createVNode as E, defineComponent as D, markRaw as O, onMounted as k, openBlock as A, ref as j, renderList as M, resolveComponent as N, toDisplayString as P, watch as F, withCtx as I } from "vue";
import { Displayable as L, Question as R, alertUser as z, useQuestionView as ee, useViewable as te } from "@vue-skuilder/common-ui";
import { NameSpacer as B, Status as V } from "@vue-skuilder/common";
import { getDataLayer as H } from "@vue-skuilder/db";
import './assets/index.css';//#region src/default/index.ts
var U = new a("default", [r]), W = D({
	name: "PianoRangeVisualizer",
	props: {
		lowestNote: {
			type: Number,
			required: !0
		},
		highestNote: {
			type: Number,
			required: !0
		},
		maxWidth: {
			type: Number,
			default: 1e3
		}
	},
	setup(e) {
		let t = j(null), n = j(800), r = b(() => {
			let e = 0;
			for (let t = 21; t <= 108; t++) isWhiteKey(t) && e++;
			return e;
		}), i = b(() => Math.min(22, n.value / Math.max(25, r.value))), a = b(() => i.value * .6), o = b(() => Math.min(e.maxWidth, i.value * r.value + 10)), isWhiteKey = (e) => {
			let t = e % 12;
			return [
				0,
				2,
				4,
				5,
				7,
				9,
				11
			].includes(t);
		}, getKeyPosition = (e) => {
			let t = 0;
			for (let n = 21; n < e; n++) isWhiteKey(n) && t++;
			return isWhiteKey(e) ? t * i.value : t * i.value - a.value / 2;
		}, getNoteLabel = (e) => {
			let t = [
				"C",
				"C#",
				"D",
				"D#",
				"E",
				"F",
				"F#",
				"G",
				"G#",
				"A",
				"A#",
				"B"
			], n = e % 12, r = Math.floor(e / 12) - 1;
			return `${t[n]}${r}`;
		};
		return k(() => {
			t.value && (n.value = t.value.clientWidth, new ResizeObserver((e) => {
				for (let t of e) n.value = t.contentRect.width;
			}).observe(t.value));
		}), {
			pianoWrapper: t,
			keyHeight: 100,
			blackKeyHeight: 60,
			whiteKeyWidth: i,
			blackKeyWidth: a,
			svgWidth: o,
			isWhiteKey,
			getKeyPosition,
			getNoteLabel
		};
	}
}), G = { class: "piano-range-container" }, K = {
	class: "piano-wrapper",
	ref: "pianoWrapper"
}, q = ["width", "height"], J = {
	class: "background-keys",
	opacity: "0.15"
}, Y = [
	"x",
	"width",
	"height"
], X = [
	"x",
	"width",
	"height"
], Z = { class: "selected-range" }, ne = [
	"x",
	"width",
	"height"
], re = [
	"x",
	"width",
	"height"
], ie = { class: "range-markers" }, ae = ["x", "height"], oe = ["x", "height"], se = ["x", "y"], ce = ["x", "y"];
function _sfc_render$1(e, t, n, r, i, a) {
	return A(), C("div", G, [w("div", K, [(A(), C("svg", {
		width: e.svgWidth,
		height: e.keyHeight + 20,
		class: "piano-svg"
	}, [
		w("g", J, [(A(), C(y, null, M(88, (t) => (A(), C(y, { key: `bg-${t}` }, [e.isWhiteKey(t + 20) ? (A(), C("rect", {
			key: 0,
			x: e.getKeyPosition(t + 20),
			y: "0",
			width: e.whiteKeyWidth,
			height: e.keyHeight,
			class: "white-key",
			stroke: "#999",
			"stroke-width": "1"
		}, null, 8, Y)) : S("", !0)], 64))), 64)), (A(), C(y, null, M(88, (t) => (A(), C(y, { key: `bg-black-${t}` }, [e.isWhiteKey(t + 20) ? S("", !0) : (A(), C("rect", {
			key: 0,
			x: e.getKeyPosition(t + 20),
			y: "0",
			width: e.blackKeyWidth,
			height: e.blackKeyHeight,
			class: "black-key"
		}, null, 8, X))], 64))), 64))]),
		w("g", Z, [(A(), C(y, null, M(128, (t) => (A(), C(y, { key: `white-${t}` }, [e.isWhiteKey(t) && t >= e.lowestNote && t <= e.highestNote ? (A(), C("rect", {
			key: 0,
			x: e.getKeyPosition(t),
			y: "0",
			width: e.whiteKeyWidth,
			height: e.keyHeight,
			class: "white-key active",
			stroke: "#666",
			"stroke-width": "1"
		}, null, 8, ne)) : S("", !0)], 64))), 64)), (A(), C(y, null, M(128, (t) => (A(), C(y, { key: `black-${t}` }, [!e.isWhiteKey(t) && t >= e.lowestNote && t <= e.highestNote ? (A(), C("rect", {
			key: 0,
			x: e.getKeyPosition(t),
			y: "0",
			width: e.blackKeyWidth,
			height: e.blackKeyHeight,
			class: "black-key active"
		}, null, 8, re)) : S("", !0)], 64))), 64))]),
		w("g", ie, [w("rect", {
			x: e.getKeyPosition(e.lowestNote) - 2,
			y: "0",
			width: 4,
			height: e.keyHeight + 5,
			class: "range-marker start"
		}, null, 8, ae), w("rect", {
			x: e.getKeyPosition(e.highestNote) + e.whiteKeyWidth - 2,
			y: "0",
			width: 4,
			height: e.keyHeight + 5,
			class: "range-marker end"
		}, null, 8, oe)]),
		w("text", {
			x: e.getKeyPosition(e.lowestNote) + 3,
			y: e.keyHeight + 12,
			class: "note-label"
		}, P(e.getNoteLabel(e.lowestNote)), 9, se),
		w("text", {
			x: e.getKeyPosition(e.highestNote) + e.whiteKeyWidth - 3,
			y: e.keyHeight + 12,
			"text-anchor": "end",
			class: "note-label"
		}, P(e.getNoteLabel(e.highestNote)), 9, ce)
	], 8, q))], 512)]);
}
e(_sfc_render$1, "_sfc_render");
//#endregion
//#region src/piano/utility/MidiConfig.vue?vue&type=script&lang.ts
var le = D({
	name: "MidiConfig",
	components: { PianoRangeVisualizer: /* @__PURE__ */ i(W, [["render", _sfc_render$1], ["__scopeId", "data-v-4b232a8b"]]) },
	props: {
		_id: {
			type: String,
			required: !0
		},
		user: {
			type: Object,
			required: !0
		}
	},
	setup(e) {
		let t = j(), n = j(!0), r = j([]), i = j([]), a = j(""), o = j(""), s = j(!1), c = j(""), l = j(""), u = j(!1), d = j("full-88"), f = j(21), m = j(108), h = j(""), g = j(0), _ = j(0), v = j([]), initNoteOptions = () => {
			let e = [
				"C",
				"C#",
				"D",
				"D#",
				"E",
				"F",
				"F#",
				"G",
				"G#",
				"A",
				"A#",
				"B"
			], t = [];
			for (let n = 0; n <= 127; n++) {
				let r = Math.floor(n / 12) - 1, i = e[n % 12];
				t.push({
					title: `${i}${r} (${n})`,
					value: n
				});
			}
			v.value = t;
		}, y = j([
			{
				title: "Full 88-key Piano (A0-C8)",
				value: "full-88"
			},
			{
				title: "76-key Keyboard (E1-G7)",
				value: "76-key"
			},
			{
				title: "61-key Keyboard (C2-C7)",
				value: "61-key"
			},
			{
				title: "49-key Keyboard (C3-C7)",
				value: "49-key"
			},
			{
				title: "37-key Keyboard (C3-C6)",
				value: "37-key"
			},
			{
				title: "25-key Keyboard (C4-C6)",
				value: "25-key"
			},
			{
				title: "Custom Range",
				value: "custom"
			}
		]), checkConfigChanged = () => {
			u.value = a.value !== c.value || o.value !== l.value || d.value !== h.value || d.value === "custom" && (f.value !== g.value || m.value !== _.value);
		}, updateCustomRangeFromPreset = () => {
			switch (d.value) {
				case "full-88":
					f.value = 21, m.value = 108;
					break;
				case "76-key":
					f.value = 28, m.value = 103;
					break;
				case "61-key":
					f.value = 36, m.value = 96;
					break;
				case "49-key":
					f.value = 48, m.value = 96;
					break;
				case "37-key":
					f.value = 48, m.value = 84;
					break;
				case "25-key":
					f.value = 60, m.value = 84;
					break;
			}
			checkConfigChanged();
		}, updateRangeAndCheckChanges = () => {
			f.value >= m.value && (m.value = f.value + 12), checkConfigChanged();
		}, playSound = () => {
			t.value?.play([
				{
					note: {
						number: 64,
						name: "E",
						octave: 4
					},
					type: "noteon",
					velocity: .4251968503937008,
					timestamp: 0
				},
				{
					note: {
						number: 64,
						name: "E",
						octave: 4
					},
					velocity: .3779527559055118,
					type: "noteoff",
					timestamp: 511.90500000002794
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					type: "noteon",
					velocity: .5275590551181102,
					timestamp: 535.8800000001211
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					velocity: .33858267716535434,
					type: "noteoff",
					timestamp: 674.9899999999907
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					type: "noteon",
					velocity: .5590551181102362,
					timestamp: 1070.8800000000047
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					velocity: .3464566929133858,
					type: "noteoff",
					timestamp: 1214.8999999999069
				},
				{
					note: {
						number: 64,
						name: "E",
						octave: 4
					},
					type: "noteon",
					velocity: .5118110236220472,
					timestamp: 1424.9400000000605
				},
				{
					note: {
						number: 64,
						name: "E",
						octave: 4
					},
					velocity: .2755905511811024,
					type: "noteoff",
					timestamp: 1576.9150000000373
				},
				{
					note: {
						number: 62,
						name: "D",
						octave: 4
					},
					type: "noteon",
					velocity: .3937007874015748,
					timestamp: 1756.9149999999208
				},
				{
					note: {
						number: 62,
						name: "D",
						octave: 4
					},
					velocity: .36220472440944884,
					type: "noteoff",
					timestamp: 1926.9899999998743
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					type: "noteon",
					velocity: .5196850393700787,
					timestamp: 1970.9600000000792
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					velocity: .36220472440944884,
					type: "noteoff",
					timestamp: 2126.009999999893
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					type: "noteon",
					velocity: .5984251968503937,
					timestamp: 2502.0050000000047
				},
				{
					note: {
						number: 60,
						name: "C",
						octave: 4
					},
					velocity: .3858267716535433,
					type: "noteoff",
					timestamp: 2853.920000000042
				},
				{
					note: {
						number: 67,
						name: "G",
						octave: 4
					},
					type: "noteon",
					velocity: .6850393700787402,
					timestamp: 2875.8649999999907
				},
				{
					note: {
						number: 67,
						name: "G",
						octave: 4
					},
					velocity: .6377952755905512,
					type: "noteoff",
					timestamp: 4497.004999999888
				}
			]);
		}, indicateHeardNotes = (e) => {
			z({
				text: `I hear a ${e.note.name}!`,
				status: V.ok
			});
		};
		F(a, () => {
			t.value?.selectInput(a.value), checkConfigChanged();
		}), F(o, () => {
			t.value?.selectOutput(o.value), checkConfigChanged();
		});
		let retrieveSettings = async () => {
			let t = await (await e.user.getCourseInterface(e._id)).getCourseSettings();
			if (t?.midiinput) {
				let e = t.midiinput.toString();
				r.value.some((t) => t.value === e) && (a.value = e, c.value = e);
			}
			if (t?.midioutput) {
				let e = t.midioutput.toString();
				i.value.some((t) => t.value === e) && (o.value = e, l.value = e);
			}
			t?.keyboardRange && (h.value = t.keyboardRange.toString(), d.value = h.value), t?.lowestNote && (g.value = parseInt(t.lowestNote.toString()), f.value = g.value), t?.highestNote && (_.value = parseInt(t.highestNote.toString()), m.value = _.value), t?.lowestNote && t?.highestNote && !t?.keyboardRange && (d.value = "custom"), u.value = !1;
		}, saveSettings = async () => {
			s.value = !0, (await H().getUserDB().getCourseInterface(e._id)).updateCourseSettings([
				{
					key: "midiinput",
					value: a.value
				},
				{
					key: "midioutput",
					value: o.value
				},
				{
					key: "keyboardRange",
					value: d.value
				},
				{
					key: "lowestNote",
					value: f.value
				},
				{
					key: "highestNote",
					value: m.value
				}
			]), c.value = a.value, l.value = o.value, h.value = d.value, g.value = f.value, _.value = m.value, u.value = !1, s.value = !1, z({
				text: "Settings updated.",
				status: V.ok
			});
		};
		return k(async () => {
			initNoteOptions();
			try {
				t.value = await p.instance(), n.value = t.value.state === "ready" || t.value.state === "nodevice";
			} catch (e) {
				console.log(`Error on midi Init: ${e}`), n.value = !1;
			}
			n.value && (t.value?.addNoteonListenter(indicateHeardNotes), t.value ? (r.value = t.value.inputs.filter((e) => e.state === "connected").map((e) => ({
				title: `${e.manufacturer}: ${e.name}`,
				value: e.id
			})), i.value = t.value?.outputs.filter((e) => e.state === "connected").map((e) => ({
				title: `${e.manufacturer}: ${e.name}`,
				value: e.id
			}))) : (r.value = [{
				title: "No inputs available",
				value: ""
			}], i.value = [{
				title: "No outputs available",
				value: ""
			}]), await retrieveSettings(), !a.value && r.value.length > 0 && (a.value = r.value[0].value), !o.value && i.value.length > 0 && (o.value = i.value[0].value));
		}), {
			midiSupported: n,
			inputs: r,
			outputs: i,
			selectedInput: a,
			selectedOutput: o,
			updatePending: s,
			playSound,
			saveSettings,
			configChanged: u,
			lowestNote: f,
			highestNote: m,
			keyboardRangeOptions: y,
			selectedKeyboardRange: d,
			noteOptions: v,
			updateCustomRangeFromPreset,
			updateRangeAndCheckChanges
		};
	}
}), Q = {
	key: 0,
	class: "custom-range-inputs d-flex gap-4"
}, ue = { class: "d-flex justify-space-between mt-3" }, de = { key: 1 };
function _sfc_render(e, t, n, r, i, a) {
	let o = N("v-toolbar-title"), s = N("v-toolbar"), c = N("v-select"), l = N("v-divider"), u = N("piano-range-visualizer"), d = N("v-btn"), f = N("v-form"), p = N("v-card-text"), m = N("v-card");
	return A(), x(m, null, {
		default: I(() => [E(s, { dense: "" }, {
			default: I(() => [E(o, null, {
				default: I(() => t[5] ||= [T("Configure Midi Device")]),
				_: 1
			})]),
			_: 1
		}), E(p, null, {
			default: I(() => [e.midiSupported ? (A(), x(f, {
				key: 0,
				onsubmit: "return false;"
			}, {
				default: I(() => [
					E(c, {
						modelValue: e.selectedInput,
						"onUpdate:modelValue": t[0] ||= (t) => e.selectedInput = t,
						items: e.inputs,
						label: "Select Input",
						hint: "Play some notes on your input device to test the connection"
					}, null, 8, ["modelValue", "items"]),
					E(c, {
						modelValue: e.selectedOutput,
						"onUpdate:modelValue": t[1] ||= (t) => e.selectedOutput = t,
						items: e.outputs,
						label: "Select Output"
					}, null, 8, ["modelValue", "items"]),
					E(l, { class: "my-4" }),
					t[8] ||= w("h3", { class: "text-subtitle-1 mb-2" }, "Keyboard Range", -1),
					E(c, {
						modelValue: e.selectedKeyboardRange,
						"onUpdate:modelValue": [t[2] ||= (t) => e.selectedKeyboardRange = t, e.updateCustomRangeFromPreset],
						items: e.keyboardRangeOptions,
						label: "Select Keyboard Range"
					}, null, 8, [
						"modelValue",
						"items",
						"onUpdate:modelValue"
					]),
					e.selectedKeyboardRange === "custom" ? (A(), C("div", Q, [E(c, {
						modelValue: e.lowestNote,
						"onUpdate:modelValue": [t[3] ||= (t) => e.lowestNote = t, e.updateRangeAndCheckChanges],
						items: e.noteOptions,
						label: "Lowest Note"
					}, null, 8, [
						"modelValue",
						"items",
						"onUpdate:modelValue"
					]), E(c, {
						modelValue: e.highestNote,
						"onUpdate:modelValue": [t[4] ||= (t) => e.highestNote = t, e.updateRangeAndCheckChanges],
						items: e.noteOptions,
						label: "Highest Note"
					}, null, 8, [
						"modelValue",
						"items",
						"onUpdate:modelValue"
					])])) : S("", !0),
					E(u, {
						"lowest-note": e.lowestNote,
						"highest-note": e.highestNote
					}, null, 8, ["lowest-note", "highest-note"]),
					w("div", ue, [E(d, {
						color: "primary",
						onClick: e.playSound
					}, {
						default: I(() => t[6] ||= [T("Test midi output")]),
						_: 1
					}, 8, ["onClick"]), E(d, {
						loading: e.updatePending,
						disabled: !e.configChanged && !e.updatePending,
						color: "info",
						class: "save-button",
						onClick: e.saveSettings
					}, {
						default: I(() => t[7] ||= [T(" Save these settings ")]),
						_: 1
					}, 8, [
						"loading",
						"disabled",
						"onClick"
					])])
				]),
				_: 1
			})) : (A(), C("div", de, t[9] ||= [w("p", null, "This quilt requires a midi input device, which is not supported by this browser.", -1), w("div", null, [w("p", null, "Try one of the following browsers:"), w("ul", null, [
				w("li", null, [w("a", { href: "https://www.google.com/chrome/" }, "Google Chrome")]),
				w("li", null, [w("a", { href: "https://www.microsoft.com/edge" }, "Microsoft Edge")]),
				w("li", null, [w("a", { href: "https://brave.com/" }, "Brave")])
			])], -1)]))]),
			_: 1
		})]),
		_: 1
	});
}
var fe = /* @__PURE__ */ i(le, [["render", _sfc_render], ["__scopeId", "data-v-6ee9020f"]]), pe = ee;
async function loadSubcourse(e) {
	let t;
	switch (e) {
		case "chess":
			t = await import("./chess-Lfm7Fsvs.js");
			break;
		case "french":
			t = await import("./french-evUMlbbq.js");
			break;
		case "math":
			t = await import("./math-DYni7rRl.js");
			break;
		case "piano":
			t = await import("./piano-BN5Btq91.js");
			break;
		case "pitch":
			t = await import("./pitch-Dn0iNqiS.js");
			break;
		case "sightSing":
			t = await import("./sightsing-CJX3k0Fd.js");
			break;
		case "typing":
			t = await import("./typing-k-ojjO7G.js");
			break;
		case "wordWork":
			t = await import("./word-work-Dd6tIKrt.js");
			break;
	}
	let n = t.default;
	return $.courses.find((e) => e.name === n.name) || $.courses.push(n), n;
}
async function loadAllSubcourses() {
	await Promise.all([
		"chess",
		"french",
		"math",
		"piano",
		"pitch",
		"sightSing",
		"typing",
		"wordWork"
	].map((e) => loadSubcourse(e)));
}
var AllCourseWare = class {
	courseWareList;
	get courses() {
		return this.courseWareList;
	}
	constructor(e) {
		this.courseWareList = e;
	}
	getCourseWare(e) {
		return this.courseWareList.find((t) => t.name === e);
	}
	cachedRawViews = null;
	allViewsRaw() {
		if (!this.cachedRawViews) {
			let e = this.allViews();
			this.cachedRawViews = Object.fromEntries(Object.entries(e).map(([e, t]) => [e, O(t)]));
		}
		return this.cachedRawViews;
	}
	allViews() {
		let e = {};
		return this.courseWareList.forEach((t) => {
			Object.assign(e, t.allViewsMap);
		}), e;
	}
	getView(e) {
		let t;
		t = typeof e == "string" ? B.getViewDescriptor(e) : e;
		let n = this.getCourseWare(t.course);
		if (n) {
			let e = n.getQuestion(t.questionType);
			if (e) {
				let r = e.views.find((e) => e.name === t.view);
				if (r) return r;
				throw console.error(`QuestionView ${t.view} not found in course ${t.course}

            descriptor: ${JSON.stringify(t)}

            course: ${n.name}
            question: ${e.name}
            views: ${e.views.map((e) => e.name).join(", ")}
            `), Error(`view ${t.view} does not exist.`);
			} else throw console.error(`Question ${t.questionType} not found in course ${t.course}

          descriptor: ${JSON.stringify(t)}

          course: ${n.name}
          questions: ${n.questions.map((e) => e.name).join(", ")}
          `), Error(`question ${t.questionType} does not exist.`);
		} else throw console.error(`Course ${t.course} not found.

        descriptor: ${JSON.stringify(t)}`), Error(`course ${t.course} does not exist.`);
	}
	toString() {
		let e = "";
		return this.courses.forEach((t) => {
			e += `Course: ${t.name}\n`, t.questions.forEach((t) => {
				e += `  Question: ${t.name}\n`, t.views.forEach((t) => {
					e += `    View: ${t.name}\n`;
				});
			});
		}), e;
	}
	allDataShapesRaw() {
		let e = [];
		return this.courseWareList.forEach((t) => {
			t.questions.forEach((t) => {
				t.dataShapes.forEach((t) => {
					e.includes(t) || e.push(t);
				});
			});
		}), e;
	}
	allDataShapes() {
		let e = [];
		return this.courseWareList.forEach((t) => {
			t.questions.forEach((n) => {
				n.dataShapes.forEach((r) => {
					e.findIndex((e) => e.course === t.name && e.dataShape === r.name) === -1 && e.push({
						course: t.name,
						dataShape: r.name,
						displayable: n
					});
				});
			});
		}), e;
	}
	getDataShape(e) {
		let t;
		if (this.getCourseWare(e.course).questions.forEach((n) => {
			n.dataShapes.forEach((n) => {
				n.name === e.dataShape && (t = n);
			});
		}), t) return t;
		throw Error(`DataShape ${B.getDataShapeString(e)} not found`);
	}
}, $ = new AllCourseWare([]);
//#endregion
export { AllCourseWare, r as BlanksCard, t as BlanksCardDataShapes, a as CourseWare, L as Displayable, fe as MidiConfig, R as Question, p as SkMidi, d as SyllableSeqVis, u as SyllableSequence, $ as allCourseWare, o as chess, U as defaultCourse, l as eventsToSyllableSequence, s as french, n as gradeSpellingAttempt, loadAllSubcourses, loadSubcourse, c as math, m as piano, h as pitch, g as sightSing, f as transposeSyllableSeq, _ as typing, pe as useQuestionView, te as useViewable, v as wordWork };

//# sourceMappingURL=index.mjs.map